import React from 'react';

import { progressBarType } from '../../constants/FormConstant';
import { MultiStepProgressBarProps } from '../../types/MultiStepRegistrationFormTypes';
import {
  NumberedProgressbar,
  ProgressBarWithSteps
} from '../ProgressBarWithSteps';

import { ProgressBar, ProgressBarContainer } from './styledComponents';

export const MultiStepProgressBar: React.FC<MultiStepProgressBarProps> = ({
  stepInfo,
  getNumberedProgressBarTitles
}) => {
  if (!stepInfo?.progress_bar_info) {
    return null;
  }

  const { type, total_steps, current_step } = stepInfo.progress_bar_info;

  if (type === progressBarType.stepProgressBar) {
    return (
      <ProgressBarWithSteps
        totalProgressBars={total_steps}
        completedBars={current_step}
      />
    );
  }

  if (type === progressBarType.numberedStepProgressBar) {
    return (
      <NumberedProgressbar
        totalProgressBars={total_steps}
        currentStep={current_step}
        numberedProgressBarStepsTitles={getNumberedProgressBarTitles()}
        customStyles={stepInfo?.progress_bar_info?.step_details?.customStyles}
      />
    );
  }

  const progressBarPercentage = (current_step / total_steps) * 100;

  return (
    <ProgressBarContainer>
      <ProgressBar width={progressBarPercentage} />
    </ProgressBarContainer>
  );
};
